import { Queue as QueueType } from '@rossum/api-client/queues';
import { alpha, Box, Paper, Stack, Switch } from '@rossum/ui/material';
import { borderRadius } from '@rossum/ui/theme';

type Props = {
  queue: QueueType;
  active: boolean;
  onToggle: (active: boolean) => void;
};

export const Queue = ({ queue, active, onToggle }: Props) => (
  <Paper
    sx={{
      py: 2,
      px: 3,
      mb: 1,
      borderRadius: borderRadius('m'),
      backgroundColor: t =>
        active
          ? t.palette.background.paper
          : alpha(t.palette.background.paper, t.palette.action.disabledOpacity),
    }}
  >
    <Stack direction="row" alignItems="center" justifyContent="space-between">
      <Stack direction="row" spacing={2} alignItems="center">
        <Box
          sx={{
            backgroundColor: t =>
              active ? t.palette.primary.main : t.palette.action.disabled,
            borderRadius: borderRadius('xl'),
            width: '10px',
            height: '10px',
          }}
        />
        <span>{queue.name}</span>
      </Stack>
      <Switch checked={active} onChange={(_, value) => onToggle(value)} />
    </Stack>
  </Paper>
);
